import GridListToggle from 'components/GridListToggle'
import UserThumbnail from 'components/UserThumbnail'
import { ViewSetting } from 'components/Dashboard/Controls'
import DashboardHeader from 'components/Dashboard/Header'
import { classNames } from 'helpers/utilities'
import { ManageDashboardTabId } from './ManageDashboard.types'

interface ManageHeaderProps {
  title: string
  address: string
  current: ManageDashboardTabId
  viewSetting: ViewSetting
  setViewSetting: (viewSetting: ViewSetting) => void
  hideViewToggle?: Array<ManageDashboardTabId>
}

export default function ManageHeader({
  title,
  address,
  current,
  viewSetting,
  setViewSetting,
  hideViewToggle
}: ManageHeaderProps) {
  const hideToggle = Array.isArray(hideViewToggle) && hideViewToggle.includes(current)

  return (
    <DashboardHeader title={title}>
      <div className="flex items-end justify-between mt-1 sm:mt-2">
        <div className="flex items-center h-10">
          <UserThumbnail
            address={address}
            className="block p-1 rounded-full pr-4 bg-white dark:bg-gray-900"
            fallbackClassName="text-gray-500"
          />
        </div>
        <div className={classNames(hideToggle ? 'hidden' : 'md:hidden', 'flex items-center h-10')}>
          <GridListToggle onChange={setViewSetting} value={viewSetting} />
        </div>
      </div>
    </DashboardHeader>
  )
}
